import { createEventEmitter as t } from "@made-people/grease-event-emitter";
const r = t();
export {
  r as uiEventEmitter
};
